export const DATABASE_TYPE = {
  MANUFACTURE: 'MANUFACTURE',
  PACKAGE: 'PACKAGE',
} as const;

export type UpdatePackageItem = {
  pill_marking_one: string;
  pill_marking_two: string | null;
  pk_no: string;
  seq_no: number;
  product_company_name: string;
  product_name: string;
  main_code: string;
  product_code: string;
  package_unit: string;
  document_no: string;
  revision_no: string;
  product_standard_no: string;
  barcode: string;
  standard_code: string;
};

export type UpdateManufacturingItem = {
  pill_marking_one: string;
  pill_marking_two: string | null;
  pk_no: string;
  seq_no: number;
  product_name: string;
  product_korean_name: string;
  product_english_name: string;
  company_name: string;
  main_code: string;
  document_no: string;
  revision_no: string;
  product_standard_no: string;
};

export type UpdateHistoryRow = {
  type: 'delete' | 'insert' | 'update';
  label: string;
  count: number;
  subRows?: (UpdatePackageItem | UpdateManufacturingItem)[];
};

export type DatabaseItem = {
  master_data_id: string;
  master_data_type: keyof typeof DATABASE_TYPE;
  master_data_name: string;
  master_data_document_id: number;
  master_data_document_url: string;
  update_history: {
    insert: UpdatePackageItem[] | UpdateManufacturingItem[] | number;
    delete: UpdatePackageItem[] | UpdateManufacturingItem[] | number;
    update:
      | {
          before: UpdatePackageItem | UpdateManufacturingItem;
          after: UpdatePackageItem | UpdateManufacturingItem;
        }[]
      | number;
  } | null;
  created_by: string;
  created_by_name: string;
  created_at: string;
};
